export default {
  common: {
    selfExplanation: "Selbsterklärung",
    prompt: "Hinweis",
    dontDisplayAgain: "Diesen Hinweis nicht erneut anzeigen.",
    continue: "Fortsetzen",
    goBack: "Zurück",

    cantFindTheCode: "Der Code wurde nicht gefunden: ",
    noContent: "Kein Inhalt",

    promptDisabledReopen: "Sie können dies auf der Seite [Startseite]->[Mein Bereich] erneut öffnen.",

    what: "Was:",
    why: "Warum:",
    learn: "Erfahren Sie mehr",
    toLearnOpen: "Um mehr zu erfahren, öffnen Sie bitte"
  },
  E1000: {
    topic: "Zielsetzung",
    content_1_M:
      "Wählen Sie das Leistungsziel für dieses Projekt aus, z. B. eine Kältemaschine, eine Kälteanlage oder ein Heizsystem. Optionen für Heizanlagen sowie kombinierte Kühlung und Heizung folgen in Kürze.",
    content_2_M:
      "Diese Auswahl steuert den iECM-Arbeitsablauf, indem sie die Systemgrenze, die erforderlichen Eingaben, die anwendbare Gerätekonfiguration und die Leistungskennzahlen zur Bewertung von Verbesserungsmöglichkeiten festlegt."
  },
  E10200: {
    topic: "Profil",
    content_1_M: "Erstellen Sie das Projektprofil mit Verwendungszweck, Auslegungsbedingungen, Flüssigkeitskühlerkonfiguration, Wetterprofil und gegebenenfalls Pumpenkonfiguration.",
    content_2_M: "Anhand dieser Informationen passt iECM den Arbeitsablauf, die Eingabefelder und die Energieaudit-Logik an die ausgewählte Zielsetzung, den Systemtyp und die Gerätekonfiguration an."
  },
  E10300: {
    topic: "Technische Daten der Bestandsgeräte",
    content_1_M:
      "Geben Sie entsprechend der ausgewählten Zielsetzung die Daten der am Standort vorhandenen Geräte ein, einschließlich Flüssigkeitskühlern und gegebenenfalls weiterer Anlagenkomponenten.",
    content_2_M: "Dadurch kann iECM das bestehende System erfassen und die passenden Gerätedaten für das Energieaudit und die Modernisierungsanalyse verwenden."
  },
  E10400: {
    topic: "Feststellungen vor Ort",
    content_1_M: "Erfassen Sie wesentliche Feststellungen, Empfehlungen, erwartete Vorteile und ergänzende Fotos aus der Standortbegehung beim Kunden.",
    content_2_M: "Diese Hinweise erläutern, warum eine Modernisierung erforderlich ist, und untermauern die Wirtschaftlichkeitsbegründung für das Energieaudit und das Angebot."
  },
  E10500: {
    topic: "Konfiguration der Ausgangsbasis",
    content_1_M:
      "Wählen Sie die am besten geeignete Datengrundlage zur Ermittlung der aktuellen energetischen Ausgangsbasis des Kunden. Verwenden Sie entweder Angaben zur Kühllast oder Energieverbrauchsabrechnungen und legen Sie anschließend die Betriebsmonate sowie die Stromtarife für Hoch- und Niedertarifzeiten fest.",
    content_2_M:
      "Diese Auswahl legt den Arbeitsablauf für die monatliche Ausgangsbasis fest und hilft iECM, den Referenzfall für das Energieaudit und die Schätzung der jährlichen Einsparungen zu erstellen."
  },
  E10610: {
    topic: "Monatliche Ausgangsbasis",
    content_1_M:
      "Fügen Sie das Betriebsprofil des Referenzmonats des Kunden hinzu oder bearbeiten Sie es. iECM verwendet dieses Profil, um die Kühllasten für die übrigen Monate des Jahres abzuschätzen und die monatliche Leistungsaufnahme der Flüssigkeitskühler zu berechnen.",
    content_2_M: "Dadurch entsteht eine belastbare Ausgangsbasis des Istzustands, anhand derer sich die jährlichen Energieeinsparungen und der Nutzen der Modernisierung klar vergleichen lassen."
  },
  E10611: {
    topic: "Betriebskalender",
    content_1_M:
      "Legen Sie fest, wann das System des Kunden für diese Ausgangsbasis betrieben wird, beispielsweise an Werktagen, an Wochenenden oder während der gesamten Woche. Die monatlichen Betriebstage werden automatisch berechnet.",
    content_2_M:
      "Die Betriebstage zeigen, wie häufig das System pro Monat und im gesamten Jahr läuft und bilden die Grundlage für die Berechnung der jährlichen Last, des Energieverbrauchs und der Einsparungen."
  },
  E10612: {
    topic: "Betriebsstunden",
    content_1_M: "Legen Sie den 24-Stunden-Betriebsplan des Referenzmonats fest, indem Sie jede Stunde als Hochtarifzeit, Niedertarifzeit oder ausgeschaltet kennzeichnen.",
    content_2_M: "Dadurch wird der Betrieb der Flüssigkeitskühler für jeden Zeitraum dem entsprechenden Wetterprofil zugeordnet, sodass iECM Last und Leistungsaufnahme genauer berechnen kann."
  },
  E10613: {
    topic: "Referenz-Flüssigkeitskühler",
    content_1_M:
      "Wählen Sie den am Standort während der Hoch- und Niedertarifzeiten eingesetzten Flüssigkeitskühler aus und anschließend das am besten passende Carrier-Ersatzmodell zur Abbildung seines Leistungsverhaltens.",
    content_2_M:
      "iECM verwendet das Ersatzmodell und die Kalibrierungseingaben, um das Leistungsverhalten des Flüssigkeitskühlers des Kunden zu simulieren und die monatliche Leistungsaufnahme der Ausgangsbasis genauer zu berechnen."
  },
  E10614: {
    topic: "Betriebslast",
    content_1_M: "Legen Sie für den Referenztag die Anzahl der stündlich betriebenen Flüssigkeitskühler und deren Lastanteil fest. iECM berechnet anschließend die stündliche Kühllast.",
    content_2_M: "Dies hilft iECM, das jährliche Kühllastprofil aufzubauen und zu schätzen, wie viele Kältemaschinen unter verschiedenen monatlichen Wetterbedingungen benötigt werden."
  },
  E10615: {
    topic: "Monatliche Kühllast",
    content_1_M: "Überprüfen Sie die gewichtete durchschnittliche Kühllast für jeden Monat. Der Basismonat basiert auf stündlichen Eingaben, während die übrigen Monate von iECM geschätzt werden.",
    content_2_M:
      "Diese monatlichen Lasten definieren die Kühlbedarfsbasis, die zur Schätzung des Kältemaschinenbetriebs, des Energieverbrauchs und der Einsparungen im Vergleich zu Nachrüstlösungen verwendet wird."
  },
  E10616: {
    topic: "Monatliche Anzahl der Flüssigkeitskühler",
    content_1_M:
      "Überprüfen Sie die für den Spitzen- und Nebenzeitbetrieb jeden Monat erforderliche Mindestanzahl an Kältemaschinen, basierend auf der monatlichen Kühllast und der verfügbaren Kältemaschinenkapazität.",
    content_2_M:
      "Dies hilft iECM, den Betrieb der bestehenden Flüssigkeitskühler im Jahresverlauf abzuschätzen, und unterstützt die monatlichen Berechnungen der Leistungsaufnahme und des Energieverbrauchs der Ausgangsbasis."
  },
  E10617: {
    topic: "Leistungsaufnahme des Flüssigkeitskühlers",
    content_1_M:
      "Prüfen Sie die monatliche mittlere Leistungsaufnahme der Flüssigkeitskühler für Hoch- und Niedertarifzeiten, berechnet anhand des Flüssigkeitskühler-Ersatzmodells, der Kühllast und der Anzahl der Flüssigkeitskühler.",
    content_2_M: "Dieses Leistungsprofil wird verwendet, um den Kältemaschinen-Energieverbrauch vor der Nachrüstung zu schätzen und die Einsparungen mit Nachrüstlösungen zu vergleichen."
  },
  E10620: {
    topic: "Monatliche Ausgangsbasis",
    content_1_M: "Fügen Sie monatliche Basiskonfigurationen basierend auf den Betriebsmustern des Kunden hinzu oder bearbeiten Sie sie, z. B. Wochentags- und Wochenendbetrieb.",
    content_2_M:
      "Diese Referenzwerte organisieren den Workflow der Versorgungsrechnungen und helfen iECM, die aktuelle energetische Ausgangsbasis für den Vergleich jährlicher Einsparungen und des Modernisierungsnutzens zu ermitteln."
  },
  E10621: {
    topic: "Betriebskalender",
    content_1_M:
      "Definieren Sie, wann das System des Kunden auf dieser Ausgangsbasis betrieben wird, beispielsweise an Wochentagen, Wochenenden oder die ganze Woche. Die monatlichen Betriebstage werden automatisch berechnet.",
    content_2_M: "Die Betriebstage zeigen, wie oft das System jeden Monat und im Laufe des Jahres läuft, und bilden die Grundlage für jährliche Last-, Energie- und Einsparungsberechnungen."
  },
  E10622: {
    topic: "Betriebsstunden",
    content_1_M: "Geben Sie für jeden Monat die täglichen Betriebsstunden während der Hoch- und Niedertarifzeiten entsprechend dem Betriebsplan des Kunden ein.",
    content_2_M: "Dadurch wird der Betrieb der Flüssigkeitskühler für jeden Zeitraum dem entsprechenden Wetterprofil zugeordnet, sodass iECM die Leistungsaufnahme genauer berechnen kann."
  },
  E10623: {
    topic: "Referenzkältemaschine",
    content_1_M:
      "Wählen Sie die während der Spitzen- und Nebenzeiten verwendete Standort-Kältemaschine aus und wählen Sie dann das nächstgelegene Carrier-Proxy-Modell, um ihre Leistung darzustellen.",
    content_2_M: "iECM verwendet das Proxy-Modell und die Kalibrierungseingaben, um die Kältemaschinenleistung des Kunden zu simulieren und die monatliche Basiskühllast genauer zu berechnen."
  },
  E10624: {
    topic: "Energieverbrauch",
    content_1_M: "Geben Sie den monatlichen Energieverbrauch des Kunden für Hoch- und Niedertarifzeiten anhand der Energieabrechnungsdaten ein.",
    content_2_M:
      "Dies hilft iECM, Abrechnungsdaten in eine betriebliche Ausgangsbasis umzuwandeln, einschließlich der geschätzten Leistungsaufnahme der Flüssigkeitskühler, der erforderlichen Anzahl der Flüssigkeitskühler und des Kühllastbedarfs."
  },
  E10625: {
    topic: "Leistungsaufnahme des Flüssigkeitskühlers",
    content_1_M:
      "Prüfen Sie die monatliche gewichtete durchschnittliche Leistungsaufnahme der Flüssigkeitskühler, die aus den Energieabrechnungsdaten des Kunden für Hoch- und Niedertarifzeiten berechnet wurde.",
    content_2_M: "Diese gewichtete mittlere Leistungsaufnahme dient zur Schätzung des Betriebs der Flüssigkeitskühler, des Kühllastbedarfs und der Einsparungen gegenüber Modernisierungslösungen."
  },
  E10626: {
    topic: "Monatliche Anzahl der Flüssigkeitskühler",
    content_1_M:
      "Prüfen Sie für jeden Monat die Mindestanzahl an Flüssigkeitskühlern für den Betrieb während der Hoch- und Niedertarifzeiten, basierend auf der monatlichen mittleren Leistungsaufnahme im Kühlbetrieb und der verfügbaren Leistungsaufnahme der Flüssigkeitskühler.",
    content_2_M:
      "Dies hilft iECM, den Betrieb der bestehenden Flüssigkeitskühler im Jahresverlauf abzuschätzen, und unterstützt die monatlichen Berechnungen der Kühllast-Ausgangsbasis und des Energieverbrauchs."
  },
  E10627: {
    topic: "Monatliche Kühllast",
    content_1_M:
      "Prüfen Sie die monatliche gewichtete durchschnittliche Kühllast, die aus Abrechnungsdaten, dem Leistungsverhalten des Flüssigkeitskühler-Ersatzmodells, der monatlichen Leistungsaufnahme und der Anzahl der Flüssigkeitskühler abgeleitet wird.",
    content_2_M:
      "Dieses Kühllastprofil bildet denselben Energiebedarf des Gebäudes vor und nach der Modernisierung ab und ermöglicht einen fairen Vergleich zwischen bestehenden und vorgeschlagenen Geräten."
  },
  E10628: {
    topic: "Leistungsaufnahme der Nebenaggregate",
    content_1_M: "Geben Sie die tatsächliche gewichtete durchschnittliche Leistungsaufnahme (kW) der Nebenaggregate, beispielsweise Pumpen und Kühltürme, während der Hoch- und Niedertarifzeiten ein.",
    content_2_M: "Dies hilft iECM, den Energieverbrauch der Nebenaggregate in die aktuelle Ausgangsbasis einzubeziehen und den gesamten Energieverbrauch der Ausgangsbasis genauer zu berechnen."
  },
  E10700: {
    topic: "Vorschau der Ausgangsbasis",
    content_1_M:
      "Prüfen Sie die Energieaudit-Ergebnisse der Ausgangsbasis und laden Sie diese herunter, einschließlich der stündlichen Kühllast, der geschätzten Leistungsaufnahme sowie der monatlichen Last und Leistungsaufnahme je Gerätetyp.",
    content_2_M: "Dadurch werden die Ergebnisse der Ausgangsbasis bestätigt und ein kundenfertiger Energieaudit-Bericht erstellt, bevor die Modellierung des vorgeschlagenen Systems beginnt."
  },
  E10800: {
    topic: "Betriebsbedingungen festlegen",
    content_1_M:
      "Wählen Sie den neuen Flüssigkeitskühlertyp aus und legen Sie die vorgeschlagenen Betriebsbedingungen fest, beispielsweise die Kaltwassertemperatur und die Einstellungen auf der Verflüssigerseite.",
    content_2_M: "Dies hilft iECM, die vorgeschlagene Anlagenkonfiguration einzurichten und das Leistungsverhalten anhand des ausgewählten Gerätetyps abzuschätzen."
  },
  E10900: {
    topic: "Neue Geräte definieren",
    content_1_M:
      "Fügen Sie die in der Modernisierungslösung verwendeten neuen Geräte hinzu und definieren Sie diese, einschließlich Flüssigkeitskühlern, Pumpen und gegebenenfalls Kühltürmen. Jeder Eintrag entspricht einer Geräteeinheit.",
    content_2_M:
      "Definieren Sie jede Geräteoption einmal. iECM berechnet die erforderlichen Aggregate und verwendet sie zur Schätzung der Performance nach der Modernisierung, der Energieeinsparungen und des ROI."
  },
  E10901: {
    topic: "Digitaler e-CAT",
    content_1_M: "Wählen Sie einen neuen Flüssigkeitskühler aus dem digitalen e-CAT aus, legen Sie Auslegungsbedingungen und Verkaufspreis fest und prüfen Sie seine Leistungskennlinie.",
    content_2_M:
      "Dies beschleunigt und vereinfacht die Auswahl des Flüssigkeitskühlers und stellt zugleich die für die Modernisierungsanalyse und Einsparungsberechnung erforderlichen Leistungsdaten bereit. Der Stückverkaufspreis dient zur Schätzung der gesamten Investitionsausgaben (CAPEX) des Projekts."
  },
  E10902: {
    topic: "Gruppierte Monate",
    content_1_M:
      "Verwenden Sie die Monatsgruppierung, wenn der gewünschte Flüssigkeitskühler nicht in der digitalen e-CAT-Bibliothek verfügbar ist. Gruppieren Sie ähnliche Monate und geben Sie anschließend die Flüssigkeitskühlerdaten und die e-CAT-Leistungsdaten ein.",
    content_2_M:
      "Die Monatsgruppierung reduziert wiederholte e-CAT-Eingaben, während die manuelle Eingabe iECM ermöglicht, benutzerdefinierte Flüssigkeitskühler für die Modernisierungsanalyse und Einsparungsberechnung zu analysieren. Der Stückverkaufspreis dient zur Schätzung der gesamten Investitionsausgaben (CAPEX)."
  },
  E10903: {
    topic: "Pumpe",
    content_1_M: "Definieren Sie die neue Pumpe und verknüpfen Sie diese mit dem Flüssigkeitskühler, dem sie in der Modernisierungslösung zugeordnet ist.",
    content_2_M: "Dies hilft iECM, die vorgeschlagene Lösung korrekt zu modellieren, indem jede Pumpe dem zugehörigen betriebenen Flüssigkeitskühler zugeordnet wird."
  },
  E10904: {
    topic: "Kühlturm",
    content_1_M: "Definieren Sie den neuen Kühlturm und verknüpfen Sie diesen mit dem Flüssigkeitskühler, dem er in der Modernisierungslösung zugeordnet ist.",
    content_2_M: "Dies hilft iECM, die vorgeschlagene Lösung korrekt zu modellieren, indem jeder Kühlturm dem zugehörigen betriebenen Flüssigkeitskühler zugeordnet wird."
  },
  E11000: {
    topic: "Modernisierungslösung",
    content_1_M:
      "Prüfen Sie die von iECM erzeugten Modernisierungslösungen, ordnen Sie diese nach Effizienz, ROI oder Investition und vervollständigen Sie die erforderliche Konfiguration jeder Option. Erstellen Sie den ECM-Bericht oder konfigurieren Sie eine Lösung für eine benutzerdefinierte Anlage neu.",
    content_2_M:
      "Dies hilft Ihnen, das überzeugendste Kundenangebot auszuwählen, ROI, Kapitalwert (NPV) und die vorgeschlagene Konfiguration abzustimmen sowie den endgültigen iECM-Bericht zu erstellen."
  },
  E12000: {
    topic: "Neu konfigurierte Lösung",
    content_1_M:
      "Konfigurieren Sie eine Modernisierungslösung manuell, indem Sie für jede Ausgangsbasis und jeden Betriebszeitraum den zugehörigen Flüssigkeitskühler und die maximale Anzahl gleichzeitig betriebener Geräte auswählen.",
    content_2_M: "Dies gibt Ihnen die Flexibilität, das Angebot anzupassen, wenn die automatisch generierte Lösung nicht am besten zum Kunden passt."
  },
  E11001: {
    topic: "Modernisierungskonfiguration",
    content_1_M:
      "Prüfen Sie die detaillierte Konfiguration der Modernisierungslösung, einschließlich maximaler Kühllast, vorgeschlagener Kälteleistung der Flüssigkeitskühler und monatlicher Anzahl betriebener Geräte.",
    content_2_M: "Dadurch wird bestätigt, wie das vorgeschlagene System ausgelegt und betrieben wird, bevor es für die Wirtschaftlichkeitsanalyse und den endgültigen ECM-Bericht verwendet wird."
  },
  E11002: {
    topic: "ROI und Kapitalwert (NPV)",
    content_1_M:
      "Prüfen und aktualisieren Sie die Wirtschaftlichkeit der Lösung über den Lebenszyklus, einschließlich Energieeinsparungen, Kosteneinsparungen, ROI, Amortisationszeit und Kapitalwert (NPV) für die Kältezentrale oder den Flüssigkeitskühler.",
    content_2_M: "Dies zeigt dem Kunden, wie die Lösung die Effizienz verbessert, die Betriebskosten senkt und langfristigen finanziellen Nutzen erzielt, einschließlich ROI und Kapitalwert (NPV)."
  },
  E11003: {
    topic: "Details der vorgeschlagenen Geräte",
    content_1_M:
      "Definieren Sie den detaillierten Modernisierungsumfang und die Konfiguration, indem Sie auswählen, welche Bestandsgeräte verbleiben und durch welche neuen Geräte die übrigen ersetzt werden.",
    content_2_M: "Dies verdeutlicht die vorgeschlagenen Geräteänderungen und hilft, einen vollständigen, kundenfertigen Modernisierungsplan und iECM-Bericht zu erstellen."
  },
  E11004: {
    topic: "Vorgeschlagene Konfiguration",
    content_1_M: "Geben Sie die Analyseannahmen, Systemdetails und Energieeinsparmaßnahmen ein, die in den endgültigen iECM-Bericht aufgenommen werden sollen.",
    content_2_M: "Dies hilft, einen vollständigen, kundenfertigen Bericht zu erstellen, der die Nachrüstgrundlage, die vorgeschlagenen Maßnahmen und den erwarteten Wert klar erklärt."
  },

  // HEATING
  E2000: {
    topic: "Zielsetzung",
    content_1_M:
      "Wählen Sie die Zielsetzung der Leistungsbewertung für dieses Projekt aus. Sie können festlegen, ob die Bewertung einen einzelnen Flüssigkeitskühler, eine Kältezentrale oder ein Heizsystem betrifft (Wärmepumpenmodernisierung und integrierte Kälte- und Wärmezentrale in Kürze verfügbar).",
    content_2_M:
      "Diese Auswahl steuert den weiteren iECM-Arbeitsablauf. Sie bestimmt die Systemgrenze, die erforderlichen Benutzereingaben, die anwendbare Gerätekonfiguration und die Leistungskennzahlen zur Bewertung von Verbesserungsmöglichkeiten."
  },
  E20200: {
    topic: "Profil",
    content_1_M:
      "Geben Sie die grundlegenden Projektinformationen und Auslegungsannahmen ein, einschließlich Projektzweck, Standort, Wetterdaten, Heizungsanwendung, Auslegungsbedingungen und Systemkonfiguration.",
    content_2_M: "Anhand dieser Eingaben kann iECM den Heizungs-Arbeitsablauf und die Berechnungen an Standort, Klima, Anwendung und bestehendes System anpassen."
  },
  E20300: {
    topic: "Technische Daten der Bestandsgeräte",
    content_1_M:
      "Fügen Sie die vorhandenen Heizgeräte hinzu und geben Sie die wesentlichen technischen Daten jeder Einheit ein, beispielsweise Gerätetyp, Leistung, Anzahl, Brennstoff- oder Energieart und effizienzbezogene Daten.",
    content_2_M: "Dies definiert das bestehende Heizsystem und liefert die Gerätedaten, die zur Ermittlung der Ausgangsbasis und zur Bewertung von Ersatzoptionen benötigt werden."
  },
  E20400: {
    topic: "Feststellungen vor Ort",
    content_1_M: "Erfassen Sie Feststellungen vor Ort, beobachtete Probleme, Empfehlungen, erwartete Vorteile und ergänzende Fotos aus der Standortbegehung beim Kunden.",
    content_2_M: "Die Feststellungen vor Ort erläutern die praktischen Gründe für die Modernisierung und liefern unterstützende Nachweise für das Energieaudit und das Kundenangebot."
  },
  E20500: {
    topic: "Konfiguration der Ausgangsbasis",
    content_1_M:
      "Wählen Sie die verfügbare Datengrundlage für die Ausgangsbasis aus: Pfad A auf Basis von Heizlastangaben oder Pfad B auf Basis von Energieverbrauchsdaten. Legen Sie anschließend die Betriebsmonate und die geltenden Energiepreise oder Tarife fest.",
    content_2_M: "Der ausgewählte Pfad bestimmt, wie die monatliche Heiz-Ausgangsbasis erstellt wird und wie die jährlichen Energiekosten und Einsparungen bewertet werden."
  },
  E20610: {
    topic: "Monatliche Ausgangsbasis",
    content_1_M:
      "Fügen Sie das repräsentative monatliche Betriebsprofil hinzu oder bearbeiten Sie es. Es dient zur Ermittlung der Heiz-Ausgangsbasis und zur Abschätzung der übrigen Monate des Jahres.",
    content_2_M: "Ein repräsentatives Betriebsprofil bietet eine einheitliche Grundlage zur Schätzung des jährlichen Wärmebedarfs, des Energieverbrauchs und der Einsparungen durch die Modernisierung."
  },
  E20611: {
    topic: "Betriebskalender",
    content_1_M: "Legen Sie die Betriebstage des Systems fest, beispielsweise Wochentage, Wochenenden oder die gesamte Woche. iECM berechnet die entsprechenden Betriebstage für jeden Monat.",
    content_2_M:
      "Die Betriebstage bestimmen, wie häufig das Heizsystem läuft, und sind eine wesentliche Eingangsgröße für die monatlichen und jährlichen Berechnungen von Last, Energieverbrauch und Einsparungen."
  },
  E20612: {
    topic: "Betriebsstunden",
    content_1_M: "Geben Sie für jeden Monat die täglichen Betriebsstunden während der Hoch- und Niedertarifzeiten entsprechend dem tatsächlichen Betriebsplan des Kunden ein.",
    content_2_M: "Dadurch wird der Heizbetrieb den richtigen Zeiträumen und Witterungsbedingungen zugeordnet, was die Genauigkeit der Last-, Energie- und Kostenberechnungen verbessert."
  },
  E20613: {
    topic: "Heizkesselbetrieb",
    content_1_M:
      "Wählen Sie den vorhandenen Heizkessel oder das Heizgerät aus, das während der Hoch- und Niedertarifzeiten betrieben wird und bestätigen Sie die zugehörigen Betriebs- und Leistungseingaben.",
    content_2_M: "Dadurch werden die Bestandsgeräte mit dem monatlichen Wärmebedarf verknüpft, sodass iECM den Gerätebetrieb und den Energieverbrauch der Ausgangsbasis abschätzen kann."
  },
  E20615: {
    topic: "Monatliche Heizlast",
    content_1_M:
      "Prüfen Sie die durchschnittliche Heizlast für Hoch- und Niedertarifzeiten in jedem Monat. Der repräsentative Monat basiert auf dem eingegebenen Lastprofil; die übrigen Monate werden von iECM geschätzt.",
    content_2_M:
      "Das monatliche Lastprofil definiert die Ausgangsbasis des Wärmebedarfs, anhand derer der Gerätebetrieb ausgelegt, der Energieverbrauch berechnet und Modernisierungslösungen verglichen werden."
  },
  E20616: {
    topic: "Monatliche Anzahl der Heizkessel",
    content_1_M:
      "Prüfen Sie für jeden Monat die erforderliche Mindestanzahl vorhandener Heizkessel oder Heizgeräte während der Hoch- und Niedertarifzeiten anhand der Heizlast und der verfügbaren Geräteleistung.",
    content_2_M: "Die Anzahl betriebener Geräte zeigt, wie das bestehende System den monatlichen Bedarf deckt, und unterstützt die Energieberechnung der Ausgangsbasis."
  },
  E20617: {
    topic: "Monatlicher Energieverbrauch",
    content_1_M: "Prüfen Sie den geschätzten monatlichen Energieverbrauch für Hoch- und Niedertarifzeiten, berechnet aus Heizlast, Gerätebetrieb und Leistungsverhalten der Bestandsgeräte.",
    content_2_M:
      "Dadurch wird die energetische Ausgangsbasis vor der Modernisierung ermittelt, anhand derer die jährlichen Energiekosten berechnet und die Einsparungen vorgeschlagener Lösungen verglichen werden."
  },
  E20623: {
    topic: "Heizkesselbetrieb",
    content_1_M:
      "Wählen Sie den vorhandenen Heizkessel oder das Heizgerät aus, dem der angegebene Energieverbrauch zugeordnet ist, und bestätigen Sie die zugehörigen Betriebs- und Leistungseingaben.",
    content_2_M:
      "Dadurch wird die Energieverbrauchs-Ausgangsbasis mit den tatsächlichen Heizgeräten verknüpft und die Umrechnung des Energieverbrauchs in Wärmebedarf und Betriebsanforderungen unterstützt."
  },
  E20627: {
    topic: "Monatlicher Energieverbrauch",
    content_1_M: "Geben Sie den monatlichen Heizenergieverbrauch des Kunden und gegebenenfalls dessen Aufteilung auf Hoch- und Niedertarifzeiten ein oder prüfen Sie diese Angaben.",
    content_2_M:
      "Die Verbrauchsdaten bilden die wichtigste Eingangsgröße der Ausgangsbasis zur Schätzung des monatlichen Wärmebedarfs, der aktuellen Energiekosten und der Einsparungen durch die Modernisierung."
  },
  E20626: {
    topic: "Monatliche Anzahl der Heizkessel",
    content_1_M: "Prüfen Sie für jeden Monat die geschätzte Anzahl vorhandener Heizkessel oder Heizgeräte, die während der Hoch- und Niedertarifzeiten benötigt werden.",
    content_2_M: "Dies zeigt, wie die Bestandsgeräte voraussichtlich betrieben werden, um den aus der Energieverbrauchs-Ausgangsbasis abgeleiteten Bedarf zu decken."
  },
  E20625: {
    topic: "Monatliche Heizlast",
    content_1_M: "Prüfen Sie die monatliche Heizlast, die aus den Energieverbrauchsdaten, dem Betriebsprofil und dem Leistungsverhalten der Bestandsgeräte geschätzt wird.",
    content_2_M: "Das abgeleitete Lastprofil liefert die gemeinsame Wärmebedarfsgrundlage, die für die Auslegung und den Vergleich vorgeschlagener Modernisierungslösungen erforderlich ist."
  },
  E20700: {
    topic: "Vorschau der Ausgangsbasis",
    content_1_M:
      "Prüfen Sie die Ergebnisse der Ausgangsbasis einschließlich monatlichem Wärmebedarf, Energieverbrauch und Energiekosten und laden Sie den Energieaudit-Bericht der Ausgangsbasis herunter.",
    content_2_M: "Dadurch kann der Benutzer den Referenzfall vor der Modernisierung überprüfen, bevor er mit der Analyse der vorgeschlagenen Geräte und Modernisierungslösungen fortfährt."
  },
  E20800: {
    topic: "Betriebsbedingungen festlegen",
    content_1_M:
      "Wählen Sie den vorgeschlagenen Wärmepumpentyp aus und definieren Sie die Betriebsbedingungen nach der Modernisierung, einschließlich der lastseitigen und quellenseitigen Temperaturbedingungen, soweit zutreffend.",
    content_2_M: "Die Betriebsbedingungen bestimmen die Leistung und Effizienz der Wärmepumpe und sind daher für genaue Berechnungen des Leistungsverhaltens des vorgeschlagenen Systems unerlässlich."
  },
  E20900: {
    topic: "Neue Geräte definieren",
    content_1_M: "Fügen Sie die vorgeschlagenen Wärmepumpenoptionen hinzu und definieren Sie die wesentlichen Angaben für jede Geräteeinheit.",
    content_2_M:
      "Jede Geräteoption wird einmal definiert, damit iECM die erforderliche Anzahl betriebener Geräte bestimmen sowie Leistungsverhalten, Einsparungen, Investition und finanzielle Rendite bewerten kann."
  },
  E20901: {
    topic: "Wärmepumpenauswahl: digitaler e-CAT",
    content_1_M: "Wählen Sie eine Wärmepumpe aus dem digitalen e-CAT aus, legen Sie die Auslegungsbedingungen und den Stückverkaufspreis fest und prüfen Sie die verfügbaren Leistungsdaten.",
    content_2_M:
      "Der digitale e-CAT liefert einheitliche Geräteauswahl- und Leistungsdaten für die Modernisierungsanalyse, während der Verkaufspreis in die geschätzten Investitionsausgaben (CAPEX) des Projekts eingeht."
  },
  E20902: {
    topic: "Wärmepumpenauswahl: manuelle Auslegung und Monatsgruppierung",
    content_1_M:
      "Verwenden Sie die manuelle Auslegung, wenn die benötigte Wärmepumpe im digitalen e-CAT nicht verfügbar ist. Gruppieren Sie Monate mit ähnlichen Betriebsbedingungen und geben Sie anschließend für jede Gruppe die Geräte- und Leistungsdaten ein.",
    content_2_M:
      "Die Monatsgruppierung reduziert wiederholte Dateneingaben und ermöglicht zugleich die Bewertung benutzerdefinierter Geräte unter repräsentativen jährlichen Betriebsbedingungen. Der Verkaufspreis geht in die geschätzten Investitionsausgaben (CAPEX) ein."
  },
  E21000: {
    topic: "Modernisierungslösungen",
    content_1_M:
      "Prüfen Sie die von iECM erzeugten Lösungen, vergleichen oder ordnen Sie diese nach Effizienz, finanzieller Rendite oder Investition, vervollständigen Sie die erforderliche Konfiguration und erstellen Sie den iECM-Bericht. Eine Lösung kann auch manuell neu konfiguriert werden.",
    content_2_M: "Dies hilft, ein geeignetes Kundenangebot zu ermitteln, die Gerätekonfiguration und finanziellen Annahmen zu verfeinern und den endgültigen Modernisierungsbericht zu erstellen."
  },
  E22000: {
    topic: "Neu konfigurierte Lösung",
    content_1_M:
      "Konfigurieren Sie eine Modernisierungslösung manuell, indem Sie die vorgeschlagenen Geräte auswählen und die maximale Anzahl gleichzeitig betriebener Geräte für jeden Basismonat und Betriebszeitraum festlegen.",
    content_2_M: "Dies bietet die Flexibilität, eine kundenspezifische Konfiguration zu erstellen, wenn eine automatisch erzeugte Lösung die Projektanforderungen nicht vollständig erfüllt."
  },
  E21001: {
    topic: "Modernisierungskonfiguration",
    content_1_M: "Prüfen Sie die detaillierte Lösungskonfiguration, einschließlich maximaler Heizlast, vorgeschlagener Wärmepumpenleistung und monatlicher Anzahl betriebener Geräte.",
    content_2_M:
      "Dadurch wird bestätigt, dass das vorgeschlagene System angemessen ausgelegt und betrieben wird, bevor die Wirtschaftlichkeitsbewertung und die Erstellung des endgültigen Berichts erfolgen."
  },
  E21002: {
    topic: "ROI und Kapitalwert (NPV)",
    content_1_M:
      "Prüfen und aktualisieren Sie die finanziellen Ergebnisse über den Lebenszyklus, einschließlich Energie- und Kosteneinsparungen, Investition, ROI, Amortisationszeit und Kapitalwert (NPV).",
    content_2_M: "Dies verdeutlicht die Betriebskostensenkung und den langfristigen finanziellen Nutzen der Lösung und unterstützt die Investitionsentscheidungen des Kunden."
  },
  E21004: {
    topic: "Details der vorgeschlagenen Geräte",
    content_1_M:
      "Definieren Sie den detaillierten Modernisierungsumfang, indem Sie festlegen, welche Bestandsgeräte verbleiben und welche vorgeschlagenen Geräte ergänzt oder als Ersatz verwendet werden.",
    content_2_M: "Dies dokumentiert die Geräteänderungen eindeutig und unterstützt einen vollständigen, kundenfertigen Modernisierungsplan und ECM-Bericht."
  },
  // wizard mode related
  E13000: {
    topic: "Schnellsetup",
    content_1_M:
      "Das Schnellsetup erfasst die wichtigsten Informationen zum Projekt, zu den vorhandenen Anlagen und zu den vorgeschlagenen Anlagen, die für eine erste Referenz und ein Nachrüstungsmodell benötigt werden.",
    content_2_M:
      "Damit kann iECM mit begrenzten Standortdaten eine erste Bewertung durchführen. iECM nutzt die bereitgestellten Eingaben und Referenzmodelle, um erste Annahmen zu erstellen, die vor der Berechnung überprüft und angepasst werden können."
  },
  E13001: {
    topic: "Annahmen prüfen",
    content_1_M:
      "Geben Sie die mindestens erforderlichen Daten ein, darunter Gebäudebranche, geschätzter Pfad, Baustellenkältemaschine, Referenzkältemaschine, vorgeschlagene Kältemaschine und monatlicher Tarif.",
    content_2_M: "Zusammen mit automatisierten Annahmen und Standardwerten ermöglicht dies eine schnelle Berechnung und Berichtserstellung."
  },
  E13002: {
    topic: "Bewertungsergebnisse",
    content_1_M:
      "Geben Sie die mindestens erforderlichen Daten ein, darunter Gebäudebranche, geschätzter Pfad, Baustellenkältemaschine, Referenzkältemaschine, vorgeschlagene Kältemaschine und monatlicher Tarif.",
    content_2_M: "Zusammen mit automatisierten Annahmen und Standardwerten ermöglicht dies eine schnelle Berechnung und Berichtserstellung."
  }
}



// WEBPACK FOOTER //
// ./src/locale/explan/de.js